export default __webpack_public_path__ + "static/media/Group 57 (1).9c359257.svg";